/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Property} from "../../models/property";
import {PropertyType} from "../../models/property-type";
import {Rule} from "../../models/rule";
import { RuleCondition, Operator, Type } from "../../models/rule-condition";
import {Component, Input} from "@angular/core";

declare var $: any;

const ID = "step2_setUpParameters";

@Component({
  selector: 'app-rule-editor-step-setup-parameters',
  templateUrl: './rule-editor-step-setup-parameters.component.html'
})
export class RuleEditorStepSetupParametersComponent {
  
  mPropertyTypes = PropertyType;
  mSourceTypes = Type;
  
  //Main DIV ID, referenced here so it can be used in the .html as well as the JQuery stuff internal to this component
  mId = ID;

  @Input()
  mRule: Rule;
  
  
  setVisible(visible: boolean): void {
    visible? $("#" + this.mId).show() : $("#" + this.mId).hide();
  }


  getGlpyhForPropertyType(property: Property): string {
    if (property != null && property.type != null) {
      switch (property.type) {
        case PropertyType.LOCATION_REFERENCE: {
          return "fa-location-arrow";
        }
        case PropertyType.OBJECT_REFERENCE: {
          return "fa-circle-o";
        }
        case PropertyType.TAG_REFERENCE: {
          return "fa-tag";
        }
        case PropertyType.USER_REFERENCE: {
          return "fa-user";
        }
        case PropertyType.ZONE_REFERENCE: {
          return "fa-bullseye";
        }
        case PropertyType.TIME: {
          return "fa-calendar";
        }
      }
    }
    return "fa-circle";
  }
  
  addParameterForProperty(property: Property): void {
    console.log("addParameterForProperty() - Property: " + (property == null? "*NULL*" : (property.id + "/" + property.property + "/" + property.type + "/" + property.name)));
    const newCondition = new RuleCondition();
    newCondition.sourceType = Type.EVENT;
    newCondition.property = property.property;
    newCondition.source = property.property;
    newCondition.propertyType = property.type;
    newCondition.operator = Operator.EQUAL;
    if (this.mRule.conditions == null) {
      console.log("Adding as only Rule Condition...");
      this.mRule.conditions = [ newCondition ];
    } else {
      let m = "Adding to current Rule Conditions:";
      this.mRule.conditions.forEach(condition => m = m + "\n\t" + condition.property + "/" + condition.propertyType + "/" + condition.operator);
      console.log(m)
      this.mRule.conditions.push(newCondition);
    }
  }
  
  getConditions(): RuleCondition[] {
    const rv: RuleCondition[] = [];
    if (this.mRule.conditions != null) {
      rv.push(...this.mRule.conditions);
    }
    return rv;
  }

}
